import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Withdrawal } from '../models/withdrawal.model';
import { WithdrawalTransaction } from '../models/withdrawal-transaction.model';

@Injectable({ providedIn: 'root' })
export class WithdrawalTransactionService {
  private baseUrl = `${environment.apiUrl}/withdrawalTransactions`;

  constructor(private http: HttpClient) {}

  getAll(isAdmin: boolean = false): Observable<WithdrawalTransaction[]> {
    const params = new HttpParams().set('isAdmin', String(isAdmin));
    return this.http.get<WithdrawalTransaction[]>(this.baseUrl, { params });
  }

  get(id: number, isAdmin: boolean = false): Observable<WithdrawalTransaction> {
    const params = new HttpParams().set('isAdmin', String(isAdmin));
    return this.http.get<WithdrawalTransaction>(`${this.baseUrl}/${id}`, { params });
  }

  addDetail(withdrawalTransactionId: number, payload: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl}/${withdrawalTransactionId}/detail`, payload);
  }

  update(withdrawalTransactionId: number, payload: { notes: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/${withdrawalTransactionId}`, payload);
  }

  // 特定のユーザーの出金依頼（admin専用）
  getAllByUserId(user_id: number): Observable<WithdrawalTransaction[]> {
    return this.http.get<WithdrawalTransaction[]>(`${this.baseUrl}/admin/${user_id}`);
  }

  create(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/create`, payload);
  }
}
